import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Input } from 'ui/input';
import { TextArea } from 'ui/text-area';

import { ViewWrapper } from 'components/partials/insight-modal/shared/components';

import { useInsight } from 'components/partials/insight-modal/insight-context';

import { FORM_DEFAULTS } from 'components/partials/insight-modal/shared/constants';
import type {
  InsightFormValues,
  InsightModalMetadata,
} from 'components/partials/insight-modal/shared/constants';

interface InsightDetailsFormProps {
  initialMetadata?: InsightModalMetadata;
}

const InsightDetailsForm = ({ initialMetadata }: InsightDetailsFormProps) => {
  const { dispatch } = useInsight();

  const { control, watch } = useForm<InsightFormValues>({
    defaultValues: {
      title: initialMetadata?.title || '',
      description: initialMetadata?.description || '',
    },
  });

  const title = watch('title');
  const description = watch('description');

  useEffect(() => {
    dispatch({
      type: 'setMetadata',
      payload: {
        reportActivePage: initialMetadata?.reportActivePage,
        reportFilters: initialMetadata?.reportFilters,
        reportId: initialMetadata?.reportId,
        relatedGoals: initialMetadata?.relatedGoals,
        source: initialMetadata?.source,
        name: initialMetadata?.name,
        isReport: initialMetadata?.isReport,
        clientId: initialMetadata?.clientId,
        title,
        description,
      },
    });
  }, [
    dispatch,
    title,
    description,
    initialMetadata?.reportActivePage,
    initialMetadata?.reportFilters,
    initialMetadata?.reportId,
    initialMetadata?.relatedGoals,
    initialMetadata?.source,
    initialMetadata?.name,
    initialMetadata?.isReport,
    initialMetadata?.clientId,
  ]);

  return (
    <ViewWrapper>
      <div className="text-navy-800 font-bold text-xl mb-6">
        Insight details
      </div>

      <Controller
        control={control}
        name="title"
        render={({ field }) => (
          <Input
            {...field}
            label="Insight title"
            placeholder="Use this area to leave a note..."
            maxLength={FORM_DEFAULTS.maxTitleLength}
            required
          />
        )}
      />
      <Controller
        control={control}
        name="description"
        render={({ field }) => (
          <TextArea
            {...field}
            label="Summary"
            placeholder="Add summary..."
            rows={FORM_DEFAULTS.descriptionRows}
            maxLength={FORM_DEFAULTS.maxDescriptionLength}
            required
          />
        )}
      />
    </ViewWrapper>
  );
};

export default InsightDetailsForm;
